import React from "react"
import { Provider } from "react-redux"
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react";

import createStore from "./src/state/createStore"
import { ConsentProvider } from "./src/context/ConsentContext"

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  const store = createStore()
  return (
    <ConsentProvider>
      <Provider store={store}>
          {element}
          <SpeedInsights />
      </Provider>
    </ConsentProvider>
  )
}
